/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Header_Usp_Items_Mobile1Inputs */

const vi_sitesettings_header_usp_items_mobile1 = /** @type {(inputs: Sitesettings_Header_Usp_Items_Mobile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dải ưu điểm (điện thoại, Mini App)`)
};

/**

* @param {Sitesettings_Header_Usp_Items_Mobile1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_header_usp_items_mobile1 = /** @type {((inputs?: Sitesettings_Header_Usp_Items_Mobile1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Header_Usp_Items_Mobile1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_header_usp_items_mobile1(inputs)
});
export { sitesettings_header_usp_items_mobile1 as "siteSettings_header_usp_items_mobile" }